import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loading: false
};

const loadingSlice = createSlice({
    name: "loader",
    initialState: initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setInitialState: (state) => {
            return initialState
        }

    },
})

export const loadingActions = loadingSlice.actions

export default loadingSlice.reducer